var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#888","size":18,"width":2}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }